"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _Modal = _interopRequireDefault(require("Modals/ModalComponent/Modal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class AddDepartmentModal extends _react.Component {
  state = {
    status_messages: {},
    warning: undefined
  };
  handleChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    component.setState({
      [name]: value,
      error: undefined,
      status_messages: status_messages
    });
  };
  handleOk = e => {
    const component = this,
      props = this.props,
      state = this.state;
    const department_to_add = state['sector[department]'];
    if (props.department) {
      if (props.department.some(function (department) {
        return department === department_to_add;
      })) {
        component.setState({
          warning: 'Département déjà ajouté'
        });
        return;
      }
    }
    props.department.push(department_to_add);
    component.setState({
      'sector[department]': undefined,
      warning: undefined
    });
    props.onClose();
  };
  handleClose = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      'sector[department]': undefined,
      warning: undefined
    });
    if (props.onClose) props.onClose();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const action_button = /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClick: component.handleOk,
      className: "c-flat-btn",
      color: "primary"
    }, "Valider");
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      open: props.open,
      onClose: props.onClose,
      title: "Ajout d'un d\xE9partement",
      "scroll-area": ".back-page",
      bemit: ['small', 'simple', 'allow-overflow'],
      "close-label": "Annuler",
      "action-buttons": action_button,
      src: props.trigger_src,
      "close-classes": "c-flat-btn c-flat-btn--red u-margin-right-10"
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['sector[department]'],
      name: "sector[department]",
      type: "text",
      label: "Num\xE9ro de d\xE9partement",
      status: state.status_messages
    }), status);
    return output;
  }
}
var _default = exports.default = AddDepartmentModal;
